export default class PublicApiClient {

  constructor(settings) {
    this.settings = settings;
  }

  async apiRequest(endPoint, opts={}) {
    const url = `https://${this.settings.publicApiDomain}/v1/${endPoint}`;
    const settings = Object.assign({
        method: 'get',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
        }
    }, opts);

    const response = await fetch(url, settings);
    return await response.json();
  }

  // MISC
  async meta() {
    return await this.apiRequest('meta', { headers: {}});
  }


  async getEndpoint(endpoint) {
    return await this.apiRequest(`endpoints/${endpoint}`, { headers: {}});    
  }

  async ping() {
    try {
      const result = await this.apiRequest("ping");
      return result.result === "success";
    } catch (err) {
      return false;
    }
  }

}
